<span *ngFor="let item of data; let i = index">
    <ng-container *ngIf="item?.isEnable === false; else elseTemplate">
        <span>{{ item.name }}</span>

        <span *ngIf="i < data.length - 1"> > </span>
    </ng-container>
    <ng-template #elseTemplate>
        <a *ngIf="item.url" [href]="item.url" style="cursor: pointer">{{ item.name }}</a>
        <a
            (click)="onRedirectCatalog(item)"
            *ngIf="!item.url"
            [style.cursor]="i === data.length - 1 ? 'default' : 'pointer'"
            >{{ item.name }}</a
        >
        <span *ngIf="i < data.length - 1"> > </span>
    </ng-template>
</span>
